// @flow
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { parse } from 'query-string';
import { withRouter } from 'react-router-dom';
import { withStyles } from '@material-ui/core/styles';
import AppBar from "@material-ui/core/AppBar";
import Tabs from "@material-ui/core/Tabs";
import Tab from "@material-ui/core/Tab";
import {
    Storage,
    SupervisorAccount,
    Timelapse,
    Warning,
    AllInbox,
    Store,
} from '@material-ui/icons';
import Typography from '@material-ui/core/Typography';
import TabNames from './TabNames';
import { SketchOrderStatusId } from "../../lib/sketchOrderStatuses";
import withOrdersRouter from '../withOrdersRouter';
import { setActiveOrdersTab } from "../../actions/ordersTabsActions";
import MetalRoofIcon from './MetalRoofIcon';

const style = () => ({
    appBar: {
        position: 'relative',
        zIndex: 100,
        backgroundColor: 'white',
    },
    tab: {
        paddingTop: 11,
    },
    count: {
        fontSize: '0.75rem',
        fontWeight: 500,
        height: 22,
        lineHeight: '22px',
        padding: '0 8px',
        marginTop: '-23px',
        marginLeft: '-10px',
        borderRadius: '11px',
        color: 'white',
        backgroundColor: 'darkgrey',
        position: 'absolute',
        left: 25,
        top: 15,
    },
});

type ProvidedProps = {
    history: {
        push: Function,
    },
    location: {
        pathname: string,
        search: string,
    },
    dispatch: Function,
    tabIndex: number,
    classes: {
        appBar: string,
        tab: string,
        count: string,
    },
    isSketchOsAdmin: boolean,
    totalOrdersInTheQueue: number,
    totalOrdersInTheVendorQueue: number,
    totalMyOrdersInProgress: number,
    totalOrdersPendingSketchOsAdmin: number,
    totalExceptionOrders: number,
    totalBillingFailedOrders: number,
    totalRushOrders: number,
    filteredRushOrders: Number,
    pendingMetalRoofOrders: Number,
    goToPendingOrders: Function,
    goToPendingVendorOrders: Function,
    goToMyOrdersInProgress: Function,
    goToOrdersPendingSketchOsAdmin: Function,
    goToOrdersWithException: Function,
    goToBillingFailedOrders: Function,
    goToRushOrders: Function,
    goToMetalRoofOrders: Function,
};

class OrdersTabs extends Component<ProvidedProps> {

    componentDidMount() {
        this.setActiveTab();
    }

    setActiveTab = () => {
        const params = parse(this.props.location.search);
        const { statusIds } = params;

        if (this.props.location.pathname === '/queue') {
            this.props.dispatch(setActiveOrdersTab(TabNames.Queue));
            return;
        }

        if (this.props.location.pathname === '/queue/vendor') {
            this.props.dispatch(setActiveOrdersTab(TabNames.VendorQueue));
            return;
        }

        if (this.props.location.pathname === '/myorders' && parseInt(statusIds, 10) === SketchOrderStatusId.InProgress) {
            this.props.dispatch(setActiveOrdersTab(TabNames.MyOrdersInProgress));
            return;
        }

        if (this.props.location.pathname === '/orders'
            && Array.isArray(statusIds)
            && parseInt(statusIds[0], 10) === SketchOrderStatusId.PendingReview
            && parseInt(statusIds[1], 10) === SketchOrderStatusId.PendingRejection) {
            this.props.dispatch(setActiveOrdersTab(TabNames.PendingAdminApproval));
            return;
        }

        if (this.props.location.pathname === '/orders' && parseInt(statusIds, 10) === SketchOrderStatusId.Exception) {
            this.props.dispatch(setActiveOrdersTab(TabNames.NeedsAttention));
            return;
        }

        if (this.props.location.pathname === '/orders' && parseInt(statusIds, 10) === SketchOrderStatusId.BillingFailed) {
            this.props.dispatch(setActiveOrdersTab(TabNames.BillingFailed));
            return;
        }

        if (this.props.location.pathname === '/orders' && params.rush === 'true') {
            this.props.dispatch(setActiveOrdersTab(TabNames.RushOrders));
            return;
        }

        if (this.props.isSketchOsAdmin) {
            this.props.dispatch(setActiveOrdersTab(TabNames.AllOrders));
            return;
        }

        this.props.dispatch(setActiveOrdersTab(TabNames.Queue));
    };
    renderTab = (icon, count) => (
        <div style={{position: 'relative'}}>
            {icon}
            {!!count &&
            <Typography
                variant="caption"
                className={this.props.classes.count}
            >
                {count.toLocaleString('en-US')}
            </Typography>
            }
        </div>
    );
    handleChange = (event, value) => {
        this.props.dispatch(setActiveOrdersTab(value));
        switch (value) {
            case TabNames.AllOrders:
                this.props.history.push('/orders');
                break;
            case TabNames.Queue:
                this.props.goToPendingOrders();
                break;
            case TabNames.VendorQueue:
                this.props.goToPendingVendorOrders();
                break;
            case TabNames.MyOrdersInProgress:
                this.props.goToMyOrdersInProgress();
                break;
            case TabNames.PendingAdminApproval:
                this.props.goToOrdersPendingSketchOsAdmin();
                break;
            case TabNames.NeedsAttention:
                this.props.goToOrdersWithException();
                break;
            case TabNames.BillingFailed:
                this.props.goToBillingFailedOrders();
                break;
            case TabNames.RushOrders:
                this.props.goToRushOrders();
                break;
            case TabNames.MetalRoof:
                this.props.goToMetalRoofOrders();
                break;
            default:
                break;
        }
    };
    render() {
        const { classes } = this.props;
        return (
            <AppBar
                position="static"
                color="default"
                className={classes.appBar}
            >
                <Tabs
                    value={this.props.tabIndex}
                    onChange={this.handleChange}
                    indicatorColor="primary"
                    textColor="primary"
                    centered
                >
                    {/* All Orders */}
                    {/* Sketch techs should not see the All Orders tab; however, we have to use CSS to hide the tab
                     because we need it to stay in the tabindex to prevent breaking navigation. A different tab
                     navigation implementation may need to be considered that better handles roles, possibly filters */}
                    <Tab
                        icon={this.renderTab(<AllInbox/>, null)}
                        label="All orders"
                        className={classes.tab}
                        style={{
                            display: this.props.isSketchOsAdmin ? 'inherit' : 'none' ,
                        }}
                    />
                    {/* Queue */}
                    <Tab
                        icon={this.renderTab(<Storage />, this.props.totalOrdersInTheQueue)}
                        label="Queue"
                        className={classes.tab}
                    />
                    {/* Vendor queue */}
                    <Tab
                        icon={this.renderTab(<Store />, this.props.totalOrdersInTheVendorQueue)}
                        label="Vendor queue"
                        className={classes.tab}
                    />
                    {/* My Orders In Progress */}
                    <Tab
                        icon={this.renderTab(<Timelapse />, this.props.totalMyOrdersInProgress)}
                        label="My orders in progress"
                        className={classes.tab}
                    />
                    {/* Pending Admin Approval */}
                    <Tab
                        icon={this.renderTab(<SupervisorAccount />, this.props.totalOrdersPendingSketchOsAdmin)}
                        label="Pending admin approval"
                        className={classes.tab}
                        style={{
                            display: this.props.isSketchOsAdmin ? 'inherit' : 'none' ,
                        }}
                    />
                    {/* Marked With Exception */}
                    <Tab
                        icon={this.renderTab(<Warning />, this.props.totalExceptionOrders)}
                        label="Needs Attention"
                        className={classes.tab}
                        style={{
                            display: this.props.isSketchOsAdmin ? 'inherit' : 'none' ,
                        }}
                    />
                    {/* Billing Failed Orders */}
                    <Tab
                        icon={this.renderTab(<Warning />, this.props.totalBillingFailedOrders)}
                        label="Failed to Bill"
                        className={classes.tab}
                        style={{
                            display: this.props.isSketchOsAdmin ? 'inherit' : 'none' ,
                        }}
                    />
                    {/* Rush Orders */}
                    <Tab
                        icon={this.renderTab(<Timelapse />, this.props.filteredRushOrders)}
                        label="Rush Orders"
                        className={classes.tab}
                    />
                    <Tab
                        icon={this.renderTab(<MetalRoofIcon active={this.props.tabIndex === 8} />, this.props.pendingMetalRoofOrders)}
                        label="Metal Roof"
                        className={classes.tab}
                    />
                </Tabs>
            </AppBar>
        );
    }
}

const mapStateToProps = (state) => {
    const { ordersTabs } = state;
    const { tabIndex } = ordersTabs;

    return {
        tabIndex,
    }
};


export default connect(mapStateToProps)(withOrdersRouter(withRouter(withStyles(style)(OrdersTabs))));
